// src/config/envio.js
// Configuraciones específicas para el sistema de envío por bultos

// Toggle principal - si es false, todo funciona como antes (precio fijo por área)
// Si es true, el precio del área se multiplica por la cantidad de bultos
export const ENVIO_POR_BULTOS_HABILITADO = false

// Colores para cada categoría de tamaño (para badges, etc.)
export const CATEGORIAS_TAMANO_COLORES = {
	P: '#28a745',  // verde - Pequeño
	M: '#ffc107',  // amarillo - Mediano
	G: '#dc3545'   // rojo - Grande
}

// Opciones para el selector de categoría en productos
export const OPCIONES_CATEGORIA_TAMANO = [
	{ value: '', label: 'Sin categoría (1 bulto por unidad)' },
	{ value: 'P', label: 'Pequeño' },
	{ value: 'M', label: 'Mediano' },
	{ value: 'G', label: 'Grande' }
]
